// Onda 2 (2026-06-02): migrado pra Antd — Card + Tag + Button + Checkbox.
import { Tag, Button, Checkbox, Typography, Space, theme } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { STATUS_LABEL, PRIORIDADE_LABEL, type Atividade } from '../Atividades';

export function ItemAtividadeNegocio({ atividade, meuEmail, onAbrir, onMudarStatus }: {
  atividade: Atividade;
  meuEmail: string;
  onAbrir: () => void;
  onMudarStatus: (status: string) => void;
}) {
  const { token } = theme.useToken();
  const s = STATUS_LABEL[atividade.status];
  const p = PRIORIDADE_LABEL[atividade.prioridade];
  const venc = atividade.data_vencimento ? new Date(atividade.data_vencimento) : null;
  const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
  const atrasada = venc && venc < hoje && atividade.status !== 'concluida';
  const concluida = atividade.status === 'concluida' || atividade.status === 'cancelada';

  return (
    <div style={{
      display: 'flex', alignItems: 'flex-start', gap: 10,
      padding: '10px 12px', marginBottom: 6,
      background: '#fff',
      border: `0.5px solid ${token.colorBorderSecondary}`,
      borderLeft: `3px solid ${atrasada ? token.colorError : (p?.cor || token.colorTextTertiary)}`,
      borderRadius: 5,
      opacity: concluida ? 0.6 : 1,
    }}>
      <Checkbox checked={atividade.status === 'concluida'}
        onChange={(e) => onMudarStatus(e.target.checked ? 'concluida' : 'pendente')}
        onClick={e => e.stopPropagation()}
        style={{ marginTop: 2 }}
      />
      <div style={{ flex: 1, cursor: 'pointer', minWidth: 0 }} onClick={onAbrir}>
        <Typography.Text strong style={{
          fontSize: 12,
          textDecoration: concluida ? 'line-through' : 'none',
          color: concluida ? token.colorTextTertiary : token.colorText,
        }}>
          {atividade.titulo}
        </Typography.Text>
        {atividade.descricao && (
          <div style={{ fontSize: 11, color: token.colorTextSecondary, marginTop: 2,
            whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
            {atividade.descricao}
          </div>
        )}
        <Space size={8} wrap style={{ marginTop: 4 }}>
          {s && <Tag bordered={false} style={{ background: s.bg, color: s.cor }}>{s.label}</Tag>}
          {atividade.tipo && (
            <Typography.Text type="secondary" style={{ fontSize: 10 }}>
              📌 {atividade.tipo}
            </Typography.Text>
          )}
          {venc && (
            <Typography.Text style={{
              fontSize: 10,
              color: atrasada ? token.colorError : token.colorTextTertiary,
              fontWeight: atrasada ? 600 : 400,
            }}>
              {atrasada ? '⚠ Atrasada · ' : '🗓 '}
              {venc.toLocaleDateString('pt-BR')}
            </Typography.Text>
          )}
          {atividade.atribuicoes.length > 0 && (
            <Typography.Text type="secondary" style={{ fontSize: 10 }}>
              👤 {atividade.atribuicoes.map(a => (
                <span key={a.email} style={{ color: a.email === meuEmail ? token.colorPrimary : undefined }}>
                  {a.email}{atividade.atribuicoes.length > 1 ? ', ' : ''}
                </span>
              ))}
            </Typography.Text>
          )}
        </Space>
      </div>
      <Button size="small" type="link" onClick={onAbrir} icon={<CheckCircleOutlined />}>
        Abrir
      </Button>
    </div>
  );
}
